import React, { useState, useRef, useEffect } from "react";
import { Card } from "primereact/card";
import equipeService from "../services/equipeService";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { InputMask } from "primereact/inputmask";
import { Password } from "primereact/password";
import { Checkbox } from "primereact/checkbox";
import { Messages } from "primereact/messages";
import usuarioService from "../services/usuarioService";
import { hideProcessing, showProcessing } from "../utils/utils";
import { Dropdown } from "primereact/dropdown";
import { MultiSelect } from "primereact/multiselect";
import { ListBox } from "primereact/listbox";
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { FilterMatchMode, FilterOperator } from 'primereact/api';

let _usuariosInitialized = false;

export default function Usuarios() {
    const [usuarios, setUsuarios] = useState([]);
    const [loading, setLoading] = useState(true);
    const [displayDialog, setDisplayDialog] = useState(false);
    const [usuario, setUsuario] = useState({perfis: []});
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    })
    const [equipes, setEquipes] = useState([]);
    const msgRef = useRef();

    // Buscar usuários ao montar o componente
    useEffect(() => {

        if (!_usuariosInitialized) {
            _usuariosInitialized = true;
            return;
        }
        
        search();
    }, []);

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };

        _filters['global'].value = value;

        setFilters(_filters);
        setGlobalFilterValue(value);
    };

    const search = async () => {
        setLoading(true);
        showProcessing();

        try {
            const response = await usuarioService.getAll();
            const responseEquipe = await equipeService.getAllAtivas();

            if (response.status === 200) {
                setUsuarios(response.data);
            }

            if (responseEquipe.status === 200) {
                const equipesAtivas = responseEquipe.data;
                setEquipes(equipesAtivas);
            }
            
            hideProcessing();
            setLoading(false);
            
        } catch (e) {
            hideProcessing();
            setLoading(false);
            
            msgRef.current.show({
                closable: false,
                severity: "error",
                summary: "Erro",
                detail: e.response?.data?.message || "Erro ao buscar usuários",
            });
        }
    };

    const statusBodyTemplate = (rowData) => {
        const severity = rowData.ativo ? "success" : "danger";
        const label = rowData.ativo ? "Ativo" : "Inativo";
        return <span className={`p-badge p-badge-${severity}`}>{label}</span>;
    };

    const actionBodyTemplate = (rowData) => {
        return (
            <div className="action-buttons">
                <Button 
                    icon="pi pi-pencil" 
                    className="button-data-table"
                    style={{ backgroundColor: "var(--app-orange-color)" }}
                    tooltip="Editar"
                    onClick={() => {selectUsuario(rowData)}}
                />
                <Button 
                    icon="pi pi-trash" 
                    className="button-data-table"
                    style={{ backgroundColor: "var(--app-red-color)" }}
                    tooltip="Deletar"
                />
            </div>
        );
    };

    const selectUsuario = async (usuario) => {

        showProcessing();
        try{

            const response = await usuarioService.getById(usuario.id);

            if (response.status === 200) {
                setUsuario(response.data);
                setDisplayDialog(true);
            }else{
                msgRef.current.show({
                    closable: false,
                    severity: "error",
                    summary: "Erro",
                    detail: "Erro ao buscar usuário",
                });
            }

        }catch(e){
            msgRef.current.show({
                closable: false,
                severity: "error",
                summary: "Erro",
                detail: e.response?.data?.message || "Erro ao buscar usuário",
            });
        }
        hideProcessing();

        
    }

    const save = async () => {
        if (!usuario.nome || !usuario.email || !usuario.senha) {
            msgRef.current.show({
                closable: false,
                severity: "warn",
                summary: "Aviso",
                detail: "Preencha todos os campos obrigatórios",
            });
            return;
        }

        try {

            showProcessing();

            const response = await usuarioService.save(usuario);

            if (response.status === 200) {
                msgRef.current.show({
                    closable: false,
                    severity: "success",
                    summary: "Sucesso",
                    detail: "Usuário salvo com sucesso",
                });
                setDisplayDialog(false);
                await search();
            } else {
                msgRef.current.show({
                    closable: false,
                    severity: "error",
                    summary: "Erro",
                    detail: "Erro ao salvar usuário",
                });
            }
        } catch (e) {
            msgRef.current.show({
                closable: false,
                severity: "error",
                summary: "Erro",
                detail: e.response?.data?.message || "Erro ao salvar usuário",
            });
        }

        hideProcessing();
    };

    const perfis = [
        {id: { perfil: "ADMINISTRADOR" }},
        {id: { perfil: "AUXILIAR_ADMINISTRATIVO" }},
        {id: { perfil: "PARECER_DE_ACESSO" }},
        {id: { perfil: "FINANCEIRO" }},
        {id: { perfil: "POS_VENDA" }},
        {id: { perfil: "TECNICO" }},
        {id: { perfil: "VENDEDOR" }},
        {id: { perfil: "ORCAMENTISTA" }}
    ]

    const descricaoPerfis = {
        "ADMINISTRADOR": "Administrador",
        "AUXILIAR_ADMINISTRATIVO": "Auxiliar Administrativo",
        "FINANCEIRO": "Financeiro",
        "POS_VENDA": "Pós-Venda",
        "TECNICO": "Técnico",
        "VENDEDOR": "Vendedor",
        "PARECER_DE_ACESSO": "Parecer de Acesso",
        "ORCAMENTISTA": "Orçamentista"
    };

    const renderHeader = () => {
        return (
            <div className="flex justify-content-end">
                <IconField iconPosition="left">
                    <InputIcon className="pi pi-search" />
                    <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Procurar..." />
                </IconField>
            </div>
        );
    };

    return (
        <div className="page-container">
            <Messages ref={msgRef} className="login-messages" />
            
            <Card className="page-card">
                <div className="page-header">
                    <h2>Gerenciamento de Usuários</h2>
                    <Button 
                        label="Novo Usuário" 
                        icon="pi pi-plus"
                        onClick={() => {
                            setUsuario({});
                            setDisplayDialog(true);
                        }}
                        className="button-new"
                    />
                </div>

                <DataTable 
                    header={renderHeader()}
                    value={usuarios} 
                    loading={loading}
                    filters={filters} 
                    stripedRows
                    className="data-table"
                    responsiveLayout="scroll"
                    paginator
                    rows={20}
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport"
                    currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} usuários"
                    rowsPerPageOptions={[10, 25, 50]}
                >
                    <Column field="nome" header="Nome" sortable style={{ minWidth: "200px" }} />
                    <Column field="email" header="Email" sortable style={{ minWidth: "200px" }} />
                    <Column field="cpf" header="CPF" style={{ minWidth: "150px" }} />
                    <Column field="telefone" header="Telefone" style={{ minWidth: "150px" }} />
                    <Column 
                        field="ativo" 
                        header="Status" 
                        body={statusBodyTemplate}
                        sortable
                        style={{ minWidth: "100px" }}
                    />
                    <Column 
                        body={actionBodyTemplate} 
                        style={{ minWidth: "100px" }}
                        header="Ações"
                    />
                </DataTable>
            </Card>

            {/* Dialog para adicionar novo usuário */}
            <Dialog 
                visible={displayDialog} 
                style={{ width: "50vw" }} 
                header={usuario.id ? "Editar Usuário" : "Novo Usuário"} 
                modal 
                className="dialog"
                headerClassName="dialog-header"
                contentClassName="dialog-content"
                onHide={() => setDisplayDialog(false)}
            >
                <div className="dialog-form-container">
                    
                    <div>
                        <label style={{ display: "block", marginBottom: "5px" }}>Nome *</label>
                        <InputText 
                            placeholder="Digite o nome completo"
                            value={usuario.nome || ""}
                            onChange={(e) => setUsuario({ ...usuario, nome: e.target.value })}
                            style={{ width: "100%" }}
                        />
                    </div>

                    <div>
                        <label style={{ display: "block", marginBottom: "5px" }}>Email *</label>
                        <InputText 
                            placeholder="Digite o email"
                            type="email"
                            value={usuario.email || ""}
                            onChange={(e) => setUsuario({ ...usuario, email: e.target.value })}
                            style={{ width: "100%" }}
                        />
                    </div>

                    <div>
                        <label style={{ display: "block", marginBottom: "5px" }}>CPF</label>
                        <InputText 
                            placeholder="Digite o CPF (xxx.xxx.xxx-xx)"
                            value={usuario.cpf || ""}
                            onChange={(e) => setUsuario({ ...usuario, cpf: e.target.value })}
                            style={{ width: "100%" }}
                        />
                    </div>
                

                
                    <div>
                        <label style={{ display: "block", marginBottom: "5px" }}>Telefone</label>
                        <InputMask
                            mask="+55 (99) 99999-9999"
                            placeholder="Digite o telefone"
                            value={usuario.telefone || ""}
                            onChange={(e) => setUsuario({ ...usuario, telefone: e.target.value })}
                            style={{ width: "100%" }}
                        />
                    </div>
                    
                    {!usuario.id && (
                        <div>
                            <label style={{ display: "block", marginBottom: "5px" }}>Senha *</label>
                            <Password 
                                placeholder="Digite a senha"
                                value={usuario.senha || ""}
                                onChange={(e) => setUsuario({ ...usuario, senha: e.target.value })}
                                style={{ width: "100%" }}
                                inputStyle={{ width: "100%" }}
                                toggleMask
                                feedback={false}
                            />
                        </div>
                    )}
                    
                    <div>
                        <label style={{ display: "block", marginBottom: "5px" }}>Status</label>
                        <Dropdown 
                            value={usuario.ativo || false} 
                            options={[{label: "ATIVO", value: true}, {label: "INATIVO", value: false}]} 
                            onChange={(e) => setUsuario({ ...usuario, ativo: e.value })} 
                            style={{ width: "100%" }}    
                        />
                    </div>

                    {usuario.perfis && usuario.perfis.some(perfil => perfil.id.perfil === "TECNICO") &&
                        <div>
                            <label style={{ display: "block", marginBottom: "5px" }}>Equipe</label>
                            <Dropdown 
                                value={usuario.equipe || null} 
                                options={equipes} 
                                onChange={(e) => setUsuario({ ...usuario, equipe: e.value })} 
                                optionLabel="nome"
                                style={{ width: "100%" }}    
                            />
                        </div>
                    }
                    
                    
                    <div>
                        <label style={{ display: "block", marginBottom: "5px" }}>Perfis</label>
                        <ListBox 
                            value={usuario.perfis || []} 
                            options={perfis} 
                            onChange={(e) => setUsuario({ ...usuario, perfis: e.value })} 
                            style={{ width: "100%" }}    
                            optionLabel="id.label"
                            itemTemplate={(option) => descricaoPerfis[option.id.perfil] || option.id.perfil}
                            multiple
                        />
                    </div>
                    
                </div>

                <div style={{ display: "flex", gap: "10px", justifyContent: "flex-end", marginTop: "15px" }}>
                    <Button 
                        label="Cancelar" 
                        icon="pi pi-times"
                        onClick={() => setDisplayDialog(false)}
                        className="button-cancel"
                    />
                    <Button 
                        label="Salvar" 
                        icon="pi pi-save"
                        onClick={save}
                        className="button-save"
                    />
                </div>
            </Dialog>
        </div>
    );
}
